import {
  applyMiddleware,
  combineReducers,
  createStore as reduxCreateStore,
} from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';

import mapReducer, {
  NAME as mapName,
} from 'sections/inside-yepstr/components/map/reducer';

const logger = createLogger({
  diff: false,
});

const createStore = () => {
  return reduxCreateStore(
    combineReducers({
      [mapName]: mapReducer,
    }),
    applyMiddleware(logger, thunk)
  );
};

export default createStore;
